/*
  custom-quote-src-capture.js

  Two jobs, both so we can tell which banner produced a quote request.

  1. On a custom page reached with ?src=..., write that value into a hidden
     field on the RFQ form, so the submitted enquiry carries it.
  2. Fire a GA4 event when a banner button is clicked, so we see clicks as
     well as completed forms.

  Load on all pages, after the DOM. No dependencies.
*/
(function () {
  'use strict';

     var ALLOWED = ['banner-fixtures', 'banner-hangers', 'banner-mannequins', 'banner-packaging', 'hub-something-else', 'menu-something-else', 'banner-thermal'];

  function init() {
    // ---- 1. stamp the source onto the RFQ form ----
    var src = new URLSearchParams(window.location.search).get('src');
    if (src && ALLOWED.indexOf(src) !== -1) {
      var forms = document.querySelectorAll('form[action*="/contact"]');
      Array.prototype.forEach.call(forms, function (form) {
        if (form.querySelector('input[name="contact[Source]"]')) return;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'contact[Source]';
        input.value = src;
        form.appendChild(input);
      });
    }

    // ---- 2. GA4 click event ----
    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('[data-eh-banner-cta]') : null;
      if (!link) return;
      if (typeof window.gtag !== 'function') return;
      window.gtag('event', 'custom_quote_banner_click', {
        banner: link.getAttribute('data-eh-banner-cta'),
        collection_path: window.location.pathname
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
